"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BusyIndicator: true
};
exports.default = exports.BusyIndicator = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _useResizeObserver = require("../utils/useResizeObserver");
var _focusManager = require("../utils/focusManager");
var _useAnnouncedMessage = require("../utils/_useAnnouncedMessage");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _BusyIndicator = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./BusyIndicator.css") : void 0);
var _BusyIndicator2 = require("./BusyIndicator.types");
Object.keys(_BusyIndicator2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _BusyIndicator2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BusyIndicator2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-busy-indicator';
/**
 * The **BusyIndicator** component provides feedback to a user during the loading of
 * another component or page.
 *
 * In order for this component to be used with the included mask, it must be
 * placed inside an HTML element that is relatively positioned unless it's using
 * the `fullScreen` type. The `cnqr-position-relative` CSS class can be used to set
 * relative positioning on any element. For example, the **BusyIndicator** might
 * be inside an application’s parent HTML container or inside a section on the page.
 *
 * > When using either the default or full-screen **BusyIndicator**, the component
 * will add an `inert` attribute to the nearest relatively-positioned parent element
 * or the `document.body`. This attribute is added to make content invisible to the
 * accessibility tree. If the component is adding the `inert` attribute to the wrong
 * element, consumers can pass the element that should be used (using the `inertContainer`
 * property). By using the `inert` attribute, keyboard navigation and speech output
 * will be disabled to underlying elements while **BusyIndicator** is active and will
 * avoid confusion to sight-impaired users and keyboard navigation users that
 * inaccessible/invisible elements are present on the page.
 *
 *
 * > If `inertContainer` is not set, `document.body` will be made `inert` which will
 * prevent screen-readers from announcing the **BusyIndicator** message.
 * Hence it is highly recommended to set `inertContainer` when showing a
 * full-screen **BusyIndicator** with text message.
 *
 * See the [Busy State](./?path=/docs/patterns-busy-state--docs)
 * patterns page for more usage examples.
 */
const BusyIndicator = exports.BusyIndicator = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(BusyIndicator, _props)) : _props;
  const {
      boxProps,
      statusProps,
      className,
      resizeContainerRef,
      id,
      inverted,
      inertContainer,
      message,
      messageProps,
      messageContainerProps,
      size,
      type,
      visible,
      showMessage,
      customBody,
      overflow,
      isScrollingContainer,
      ariaBusy,
      circleClassName
    } = props,
    otherProps = __rest(props, ["boxProps", "statusProps", "className", "resizeContainerRef", "id", "inverted", "inertContainer", "message", "messageProps", "messageContainerProps", "size", "type", "visible", "showMessage", "customBody", "overflow", "isScrollingContainer", "ariaBusy", "circleClassName"]);
  const classnames = _bind.default.bind(_BusyIndicator.default);
  let uniqueId = (0, _useUniqueId.default)();
  if (id) {
    uniqueId = id;
  }
  const {
    width: containerWidth
  } = (0, _useResizeObserver.useResizeObserver)({
    targetRef: resizeContainerRef
  });
  let sizeProp = size;
  if (containerWidth) {
    if (containerWidth <= 48) {
      sizeProp = 'xs';
    } else {
      sizeProp = 'sm';
    }
  }
  const isDefault = typeof type === 'undefined' || type === 'fullPage';
  const isSmallDefault = isDefault && sizeProp === 'sm';
  const isFullScreen = type === 'fullScreen';
  const isInline = type === 'inline';
  const isBlock = type === 'block';
  const focusManagerRef = (0, _react.useRef)();
  const containerRef = (0, _react.useRef)(null);
  const inertContainerRef = (0, _react.useRef)(null);
  const activeElementRef = (0, _react.useRef)(null);
  const [isMounted, setIsMounted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsMounted(true);
  }, []);
  /**
   * Note: JAWS requires an element with `role="status"` to be initially rendered on the page,
   * and then dynamically update its content in order for it to be announced.
   */
  const announcedMessage = (0, _useAnnouncedMessage.useAnnouncedMessage)({
    announce: isFullScreen,
    message,
    disableReset: true
  }, [visible, message, isFullScreen]);
  (0, _useUniversalLayoutEffect.default)(() => {
    var _a, _b;
    // inline and block types do not require setting the 'inert' attribute
    if (isInline || isBlock) return () => {};
    // if a previous inert element existed, clear that before proceeding
    if (inertContainerRef.current) {
      inertContainerRef.current.removeAttribute('inert');
      inertContainerRef.current.style.overflow = overflow || '';
    }
    let inertElement;
    // if the consumer passed an 'inertContainer', just use that
    if (inertContainer) {
      inertElement = inertContainer;
    } else {
      // fullscreen should just use document.body so we will skip this step
      // and let it get set as the fallback below
      if (!isFullScreen) {
        inertElement = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetParent;
      }
      if (!inertElement) {
        inertElement = document.body;
      }
    }
    if (inertElement) {
      inertContainerRef.current = inertElement;
      if (visible) {
        if (inertElement.contains(document.activeElement)) {
          activeElementRef.current = document.activeElement;
        }
        inertElement.setAttribute('inert', 'true');
        inertElement.style.overflow = 'clip';
      } else {
        inertElement.removeAttribute('inert');
        inertElement.style.overflow = overflow || '';
        if (!document.activeElement || document.activeElement === document.body) {
          (_b = activeElementRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        activeElementRef.current = null;
      }
    }
    if (isScrollingContainer && containerRef.current && inertContainerRef.current) {
      // if the container is a scrolling container, we need to adjust the top position
      // of the mask to match the scroll position of the container
      containerRef.current.style.top = `${inertContainerRef.current.scrollTop}px`;
    }
    return () => {
      var _a;
      inertElement.removeAttribute('inert');
      inertElement.style.overflow = overflow || '';
      if (!document.activeElement || document.activeElement === document.body) {
        (_a = activeElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      }
      activeElementRef.current = null;
    };
  }, [visible, inertContainer]);
  const _handleFocusManager = node => {
    if (isFullScreen && visible && node) {
      focusManagerRef.current = new _focusManager.FocusManager({
        trapNode: node
      });
    }
  };
  const _renderBusyIndicator = () => (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__progress`)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__circle`, `${CSS_BLOCK}__circle--0`, {
      [`${CSS_BLOCK}__circle--inverted`]: inverted
    }, circleClassName)
  }), sizeProp !== 'xs' && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__circle`, `${CSS_BLOCK}__circle--1`, {
      [`${CSS_BLOCK}__circle--inverted`]: inverted
    }, circleClassName)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__circle`, `${CSS_BLOCK}__circle--2`, {
      [`${CSS_BLOCK}__circle--inverted`]: inverted
    }, circleClassName)
  })))));
  const hideMessage = !showMessage || isSmallDefault;
  const _renderMessaging = messaging => {
    const messageContainerClassNames = classnames(`${CSS_BLOCK}__message-box`, messageContainerProps === null || messageContainerProps === void 0 ? void 0 : messageContainerProps.className, {
      [`${CSS_BLOCK}__message-box--screen-reader-only`]: hideMessage
    });
    const paragraphClassNames = classnames(`${CSS_BLOCK}__message`, messageProps === null || messageProps === void 0 ? void 0 : messageProps.className);
    return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, messageContainerProps, {
      className: messageContainerClassNames
    }), /*#__PURE__*/_react.default.createElement("p", Object.assign({}, messageProps, {
      className: paragraphClassNames,
      id: `${uniqueId}-message`
    }), messaging));
  };
  if (!visible) {
    return null;
  }
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}__mask`]: !isInline && !isBlock,
    [`${CSS_BLOCK}__mask--full-screen`]: isFullScreen,
    [`${CSS_BLOCK}--inline`]: isInline,
    [`${CSS_BLOCK}--block`]: isBlock,
    [`${CSS_BLOCK}--xs`]: sizeProp === 'xs' && !isFullScreen,
    [`${CSS_BLOCK}--sm`]: sizeProp === 'sm' && !isFullScreen,
    [`${CSS_BLOCK}--lg`]: sizeProp === 'lg'
  });
  const boxClassNames = classnames(`${CSS_BLOCK}__box`, {
    [`${CSS_BLOCK}__box--inline`]: isInline,
    [`${CSS_BLOCK}__box--centered`]: !isInline && !isBlock,
    [`${CSS_BLOCK}__box--full-page`]: type === 'fullPage',
    [`${CSS_BLOCK}--inverted`]: inverted
  }, boxProps === null || boxProps === void 0 ? void 0 : boxProps.className);
  const busyIndicator = /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([containerRef, _handleFocusManager, ref]),
    "aria-busy": ariaBusy
  }), customBody || (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, boxProps, {
    className: boxClassNames
  }), _renderBusyIndicator(), /*#__PURE__*/_react.default.createElement("span", Object.assign({}, statusProps, {
    id: uniqueId,
    role: "status",
    "aria-describedby": isInline ? undefined : `${uniqueId}-message`,
    "aria-label": isInline ? message : undefined,
    "aria-live": isFullScreen ? 'assertive' : 'polite',
    className: classnames(`${CSS_BLOCK}__status`, statusProps === null || statusProps === void 0 ? void 0 : statusProps.className, {
      [`${CSS_BLOCK}__message-box--screen-reader-only`]: !announcedMessage || hideMessage
    })
  }), announcedMessage && _renderMessaging(announcedMessage)), !announcedMessage && _renderMessaging(message))));
  return isFullScreen && isMounted ? /*#__PURE__*/_reactDom.default.createPortal(busyIndicator, document.body, 'busy-indicator-portal') : busyIndicator;
});
BusyIndicator.displayName = 'BusyIndicator';
var _default = exports.default = BusyIndicator;